<template>
  <div class="Block-Time-Comments-Fire">
    <time class="Block-Time-Comments-Fire__date">{{ get_time }}</time>
    <a class="Block-Time-Comments-Fire__author" target="_blank" :href="props.link" v-if="props.link">
      {{ props.link }}
    </a>
    <router-link class="Block-Time-Comments-Fire__author" :to="get_pathObj" v-else-if="props.author">
      {{ props.author.name }}
    </router-link>
    <CounterComment
      class="Block-Time-Comments-Fire__comments"
      :count="props.initCommentsCount"
      :newCommentsCounter="props.commentsCount"
      :isClickable="true"
      @click="toCallComments"
    />
    <div class="Block-Time-Comments-Fire__fire" v-if="props.isFire">
      <img :src="require('@shared/images/icons/trendCoins.svg')" alt="fire">
    </div>
  </div>
</template>

<script setup>
  import { Props } from './scripts/props'
  import { computed } from "vue";
  import { formatTime_dnShort_h } from '@shared/utils/time/formated';
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
  //--------------------------------
  import CounterComment from '@ui/Counters/CounterComment/CounterComment.vue';
  //--------------------------------
  const props = defineProps(Props());
  const emit = defineEmits(['callComments']);
  //--------------------------------
  //Получить отфарматированное время создания сигнала
  const get_time = computed(() => formatTime_dnShort_h(props.date));
  //Получить объект перехода
  const get_pathObj = computed(() => {
    return (props.isMine) ?
      { name: PATHS_NAME.USER.SETTINGS} :
      { name: PATHS_NAME.OTHER_USERS.PROFILE, params: { username: props.author.username } };
  });
  //--------------------------------
  //Отправить emit на вызов комментариев к контентной странице
  const toCallComments = () => emit('callComments');
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>
